"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MyselfSection = require("./MyselfSection");
Object.keys(_MyselfSection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MyselfSection[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MyselfSection[key];
    }
  });
});
var _OtherCustomersSection = require("./OtherCustomersSection");
Object.keys(_OtherCustomersSection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OtherCustomersSection[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OtherCustomersSection[key];
    }
  });
});
